module.exports = __webpack_public_path__ + "static/img/szafa_dso_50.fb8ee33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/kopai/szafa_dso_50.svg
// module id = zap3
// module chunks = 1